module.exports = __webpack_public_path__ + "media/images/area/area_akitaM400-30ba4f700897a9d39e2f1f8c133cc38c.jpg";